import { AbpHttpInterceptor } from 'abp-ng2-module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import * as ApiServiceProxies from './service-proxies';
import { TokenAuthServiceProxy, TokenServiceProxy } from './token-auth-service-proxy';
import { ServiceProxy as StripeServiceProxy } from './stripe-service-proxy';
import { BackgroundCallErrorInterceptor } from '@shared/helpers/BackgroundCallErrorInterceptor';
@NgModule({
    providers: [
        ApiServiceProxies.OfficeServiceProxy,
        ApiServiceProxies.TeamServiceProxy,
        ApiServiceProxies.CachingServiceProxy,
        ApiServiceProxies.CommonLookupServiceProxy,
        ApiServiceProxies.CommonServiceProxy,
        ApiServiceProxies.EditionServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.NotificationServiceProxy,
        ApiServiceProxies.OrganizationUnitServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.ProfileServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.TenantDashboardServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.WorkspaceSettingsServiceProxy,
        ApiServiceProxies.TimingServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.UserLoginServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        TokenAuthServiceProxy,
        ApiServiceProxies.TenantRegistrationServiceProxy,
        ApiServiceProxies.HostDashboardServiceProxy,
        ApiServiceProxies.PaymentServiceProxy,
        ApiServiceProxies.InvoiceServiceProxy,
        ApiServiceProxies.SubscriptionServiceProxy,
        ApiServiceProxies.UiCustomizationSettingsServiceProxy,
        ApiServiceProxies.DashboardServiceProxy,
        ApiServiceProxies.ScheduleServiceProxy,
        ApiServiceProxies.AgendaServiceProxy,
        ApiServiceProxies.TaskServiceProxy,
        ApiServiceProxies.OutlookServiceProxy,
        ApiServiceProxies.AttachmentServiceProxy,
        ApiServiceProxies.OneDriveServiceProxy,
        ApiServiceProxies.UserProductivityServiceProxy,
        ApiServiceProxies.ContactServiceProxy,
        ApiServiceProxies.PinnedServiceProxy,
        ApiServiceProxies.CalendarServiceProxy,
        ApiServiceProxies.AnnouncementServiceProxy,
        ApiServiceProxies.UserNotificationSubscriptionServiceProxy,
        ApiServiceProxies.ReleaseServiceProxy,
        ApiServiceProxies.TicketServiceProxy,
        ApiServiceProxies.LinkServiceProxy,
        ApiServiceProxies.BotFrameworkServiceProxy,
        ApiServiceProxies.CompanyServiceProxy,
        ApiServiceProxies.NotesServiceProxy,
        ApiServiceProxies.DriveCategoryServiceProxy,
        ApiServiceProxies.UserActivityHistoryServiceProxy,
        ApiServiceProxies.TaskWatcherServiceProxy,
        ApiServiceProxies.ConversationServiceProxy,
        ApiServiceProxies.ProjectCommentServiceProxy,
        ApiServiceProxies.TaskAssigneServiceProxy,
        ApiServiceProxies.ProjectServiceProxy,
        ApiServiceProxies.ProjectFieldServiceProxy,
        ApiServiceProxies.AgendaConsolidatedServiceProxy,
        ApiServiceProxies.GridPreferenceServiceProxy,
        ApiServiceProxies.FavoriteServiceProxy,
        TokenServiceProxy,
        ApiServiceProxies.StripeServiceProxy,
        ApiServiceProxies.TimeTrackingServiceProxy,
        ApiServiceProxies.ClientAutomationServiceProxy,
        ApiServiceProxies.ClientSettingsServiceProxy,
        ApiServiceProxies.EmailAutomationServiceProxy,
        ApiServiceProxies.EmailAutomationSettingsServiceProxy,
        ApiServiceProxies.EmailAutomationsServiceProxy,
        ApiServiceProxies.TaskConversationCalloutsServiceProxy,
        ApiServiceProxies.CalendarSettingsServiceProxy,
        ApiServiceProxies.EventTypeServiceProxy,
        // Hearings and meetings P4: the My day calendar-notice banner.
        ApiServiceProxies.CalendarNoticeServiceProxy,
        ApiServiceProxies.CalendarAccessServiceProxy,
        ApiServiceProxies.MyCalendarSettingsServiceProxy,
        ApiServiceProxies.EventServiceProxy,
        ApiServiceProxies.SchedulingServiceProxy,
        ApiServiceProxies.EmailSharedInboxServiceProxy,
        ApiServiceProxies.ConnectedAppsServiceProxy,
        ApiServiceProxies.TaskContextServiceProxy,
        ApiServiceProxies.TaskLeadStageServiceProxy,
        ApiServiceProxies.LeadPipelineServiceProxy,
        ApiServiceProxies.LostReasonsServiceProxy,
        // Pipeline Analytics (Epic PA001): the Pipeline page's Analytics window.
        ApiServiceProxies.PipelineAnalyticsServiceProxy,
        ApiServiceProxies.TaskCompletionServiceProxy,
        // Adaptive Onboarding + Organization Intelligence (P0-13-a, NSwag N0).
        ApiServiceProxies.OnboardingServiceProxy,
        ApiServiceProxies.OnboardingConnectionServiceProxy,
        ApiServiceProxies.OnboardingQaServiceProxy,
        ApiServiceProxies.DiscoveryJobsServiceProxy,
        ApiServiceProxies.ProductEventsServiceProxy,
        ApiServiceProxies.OrgIntelligenceServiceProxy,
        ApiServiceProxies.WorkspaceGridLayoutServiceProxy,
        ApiServiceProxies.ProjectTemplateFolderServiceProxy,
        StripeServiceProxy,
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true },
        // Right after (inside) ABP's interceptor, so a silent background call's failure gets no ABP dialog (F1).
        { provide: HTTP_INTERCEPTORS, useClass: BackgroundCallErrorInterceptor, multi: true }
    ]
})
export class ServiceProxyModule { }
